(function ($) {
  Drupal.behaviors.perfectionist_pro_carousel_formatter_v2 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $thismodule = $('.perfectionist_pro_carousel_1', context);

      $thismodule.each(function () {
        var $self = $(this);
        var triggerMod = '.perfectionist_pro_carousel_1';
        var controller = new ScrollMagic.Controller();
        var moduleWillFade =
          $self.find('.pp_carousel_1_data_scrollmagic').data('scrollmagic') === 1;
        var dirSwap = $('html[dir="rtl"]').length;
        var urlHash = window.location.href.split('#')[1];
        var hasFaded = false;
        var offset, fadeThisModuleScene;
        var carouselChevrons = '.el_boutique_carouselnav';
        var carouselPagDots = '.el_boutique_carousel_pagination_dot';
        var placeholderRow = '.js-sp19-ppro__mod2-carouselinfo';
        var collapseSection = '.js-sp19-ppro__mod2-mob-control--2';
        var copySection = '.js-sp19-ppro__mod2-carouselcopy';
        var totalSlides = $self.find('.js-sp19-ppro__mod2-carouselinfo').length;
        var carouselSlideTracker = 1;
        var reset = 1;
        var marginResetLeft = 0;
        var mobileWidth = 768;
        var moduleOffsetMargin = 85;
        var scrollAnimSpeed = 1500;
        var extraElements,
          pagTarget,
          bgurlFill,
          bgurlOutline,
          bgurlFillURL,
          bgurlOutlineURL,
          originalPagination,
          clonePagination,
          $mppTarget;
        var $thisparent = $self.parent();

        if ($thisparent.parents('.node-elc-nodeblock').length) {
          $mppTarget = $self.parents().eq(2).prev('.mpp');
        } else {
          $mppTarget = $self.parent().prev('.mpp');
        }

        $mppTarget.addClass('mpp_qs_detached');
        var $targetDetach = $mppTarget.find('.product-brief');
        var $qsOpen = $mppTarget.find(
          'a.button__quickshop.product-brief__button-quickshop.js-quickshop-show'
        );
        var $qsClose = $mppTarget.find(
          'a.product-brief__button-quickshop--close.js-quickshop-hide'
        );
        var $targetAttach = $self.find('.js-sp19-ppro__mod2-quickshop');

        $qsOpen.addClass('shop_now_dark shop_now_centered');
        $qsClose.addClass('shop_now_light shop_now_white shop_now_centered');

        /* LEGACY CODE FORMATTER V1.
        /--------------------------------------------------------------------------
        / Estée.
        /--------------------------------------------------------------------------
        / Remove the additional wrapper contents on the carousel content-blocks to
        / prevent styling issues.
        */
        extraElements = $self.find('.node.node-elc-nodeblock, .content, div:not([class])');
        extraElements.contents().unwrap();

        /*
         * --------------------------------------------------------------------------
         * CONTINUOUS CAROUSEL V1.5
         * --------------------------------------------------------------------------
         */
        /*
        /--------------------------------------------------------------------------
        / Wrap the carousel in the standard boutique class, 'el_boutique_wrapper'
        /--------------------------------------------------------------------------
        */
        $self.wrapAll('<div class="el_boutique_wrapper sp19-ppro__spp-carousel-v1"></div>');

        /*
        /--------------------------------------------------------------------------
        / Remove the placholder slides for this carousel
        /--------------------------------------------------------------------------
        */
        $self.find('.el_boutique_carousel_holder').remove();

        /*
        /--------------------------------------------------------------------------
        / Handle pagination dots.
        /--------------------------------------------------------------------------
        */
        $self
          .find('.el_boutique_carousel_pagination')
          .detach()
          .insertBefore($self.find('.el_boutique_carouselContainer'));
        pagTarget = $self.find('.el_boutique_carousel_pagination');
        for (var i = 1; i <= totalSlides; i++) {
          pagTarget.append('<div class="el_boutique_carousel_pagination_dot"></div>');
        }
        pagTarget.find('.el_boutique_carousel_pagination_dot').each(function (i) {
          $(this).addClass('el_boutique_carousel_pagination_dot_' + (i + 1));
        });
        // Clone the pag dots to hide/show active pag dot according to CMS-loaded values.
        bgurlFill = $self.find('.data_bgurlFill');
        bgurlOutline = $self.find('.data_bgurlOutline');
        bgurlFillURL = bgurlFill.data('bgurlfill');
        bgurlOutlineURL = bgurlOutline.data('bgurloutline');

        originalPagination = $self.find('.el_boutique_carousel_pagination:eq(0)');
        clonePagination = originalPagination.clone();
        originalPagination.css({
          'z-index': '3'
        });
        clonePagination.insertAfter(originalPagination);
        originalPagination.find('.el_boutique_carousel_pagination_dot').css({
          background: 'transparent url(' + bgurlFillURL + ') no-repeat 0 center'
        });
        originalPagination.find('.el_boutique_carousel_pagination_dot:not(:eq(0))').css({
          opacity: '0'
        });
        clonePagination.find('.el_boutique_carousel_pagination_dot').css({
          background: 'transparent url(' + bgurlOutlineURL + ') no-repeat 0 center'
        });
        // Remove the classes.
        $self.find('.data_bgurlFill, .data_bgurlOutline').remove();

        // UPDATED CODE FOR FORMATTER V2.
        // If module is called in URL, scroll to module.
        function checkURL() {
          if (urlHash === 'perfectionist_pro_carousel') {
            $('html,body').animate(
              {
                scrollTop: $self.offset().top - moduleOffsetMargin
              },
              scrollAnimSpeed
            );
          }
        }
        checkURL();

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $self.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $self.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        // Determine the direction in which we are to animate.
        // This only applies if an arrow is clicked as we may
        // be going left || right.
        function handleAnimationDirection(src) {
          if (src === 0) {
            if (dirSwap) {
              carouselSlideTracker++;
            } else {
              carouselSlideTracker--;
            }
          } else {
            if (dirSwap) {
              carouselSlideTracker--;
            } else {
              carouselSlideTracker++;
            }
          }
        }

        // Manage tracking of slide between both click elements.
        function trackSlideNumber(src, passedNum) {
          // Manage click source.
          if (src === 'arrow') {
            handleAnimationDirection(passedNum);
          } else {
            carouselSlideTracker = passedNum;
          }
          // Account for infinite scrolling.
          if (carouselSlideTracker === totalSlides + 1) {
            carouselSlideTracker = reset;
          } else if (carouselSlideTracker === marginResetLeft) {
            carouselSlideTracker = totalSlides;
          }
          // Carry out the animations.
          carouselEvents(carouselSlideTracker);
        }

        // Animating the slide copy & pag dot styles.
        function carouselEvents(passedNum) {
          $self
            .find('.el_boutique_carousel_pagination')
            .eq(0)
            .find('.el_boutique_carousel_pagination_dot_' + passedNum)
            .css('opacity', '1')
            .siblings()
            .css('opacity', '0');
          $self
            .find('.js-sp19-ppro__mod2-carouselinfo-' + passedNum)
            .removeClass('hideContent')
            .addClass('fadeFromRight')
            .siblings()
            .removeClass('fadeFromRight')
            .addClass('hideContent');
        }

        // Pagination dots click event.
        function carouselPagDotClicks() {
          $self.find(carouselPagDots).once(function () {
            $(this).click(function () {
              // Determine the pag dot number.
              trackSlideNumber('pag', $(this).index() + 1);
            });
          });
        }
        carouselPagDotClicks();

        // Arrows click event.
        function carouselArrowClicks() {
          $self.find(carouselChevrons).once(function () {
            $(this).click(function () {
              // Determine if arrow 0 || 1, i.e., left || right.
              trackSlideNumber('arrow', $(this).index());
            });
          });
        }
        carouselArrowClicks();

        // Mobile.
        // Expand/collapse the rows.
        function showCollapsedContent() {
          $self.find(placeholderRow).once(function () {
            $(this).click(function () {
              $(this).addClass('expandSection');
            });
          });
          $self.find(collapseSection).once(function () {
            $(this).click(function (event) {
              event.stopPropagation();
              $(this).parent().removeClass('expandSection');
            });
          });
        }

        // Append quickshops to the correct product copy section.
        function appendMobQuickshop() {
          // Need to wait for mpp to load.
          $(window).on('load', function () {
            $targetDetach.detach().insertAfter($targetAttach);
            $mppTarget.detach().appendTo($self);
            // Remove padding if there are no quickshops.
            if (!$(placeholderRow).siblings('li.product-brief').length) {
              $(placeholderRow).closest(copySection).addClass('removePadding');
            }
          });
        }

        if ($(window).width() < mobileWidth) {
          showCollapsedContent();
          appendMobQuickshop();
        }

        $(window).on('load', function () {
          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.
            if ($self.data('offset')) {
              offset = $self.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });
            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
